<div class="bg-slate-900 text-white border border-slate-700 rounded-lg overflow-hidden">
  <button
    type="button"
    class="w-full px-5 py-4 flex justify-between items-center text-left"
    (click)="expanded = !expanded"
  >
    <span class="font-semibold">
      {{ 'project.steps.rfd.evaluation.legend.title' | transloco }}
    </span>
    <span class="text-xs text-slate-300 flex items-center gap-2">
      {{ (expanded ? 'common.hide' : 'common.show') | transloco }}
      <i class="pi text-xs" [ngClass]="expanded ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
    </span>
  </button>

  @if (expanded) {
    <div class="px-5 pb-5">
      <div class="text-xs text-slate-400 mb-4">
        {{ 'project.steps.rfd.evaluation.legend.subtitle' | transloco }}
      </div>

      <div class="flex flex-col gap-3">
        <!-- No rating -->
        <div
          class="bg-slate-700/60 border border-slate-600 rounded-md px-4 py-3 flex items-start gap-4"
        >
          <div class="flex items-center gap-2 min-w-[88px] text-slate-300">
            <i class="pi pi-ban text-red-500 text-sm" aria-hidden="true"></i>
          </div>
          <div>
            <div class="font-semibold text-sm">
              {{ 'project.steps.rfd.evaluation.legend.noRating' | transloco }}
            </div>
            <div class="text-xs text-slate-300 mt-0.5">
              {{ 'project.steps.rfd.evaluation.legend.noRating.description' | transloco }}
            </div>
          </div>
        </div>

        <!-- Not seen -->
        <div
          class="bg-slate-700/60 border border-slate-600 rounded-md px-4 py-3 flex items-start gap-4"
        >
          <div class="flex items-center gap-2 min-w-[88px] text-slate-300">
            <i class="pi pi-eye-slash text-red-500 text-sm" aria-hidden="true"></i>
          </div>
          <div>
            <div class="font-semibold text-sm">
              {{ 'project.steps.rfd.evaluation.legend.notSeen' | transloco }}
            </div>
            <div class="text-xs text-slate-300 mt-0.5">
              {{ 'project.steps.rfd.evaluation.legend.notSeen.description' | transloco }}
            </div>
          </div>
        </div>

        <!-- 1 star -->
        <div
          class="bg-slate-700/60 border border-slate-600 rounded-md px-4 py-3 flex items-start gap-4"
        >
          <div class="flex items-center gap-2 min-w-[88px] text-slate-300">
            <div class="flex items-center gap-0.5">
              <i class="pi pi-star-fill text-red-500 text-sm" aria-hidden="true"></i>
              <i class="pi pi-star text-slate-400 text-sm" aria-hidden="true"></i>
              <i class="pi pi-star text-slate-400 text-sm" aria-hidden="true"></i>
              <i class="pi pi-star text-slate-400 text-sm" aria-hidden="true"></i>
            </div>
          </div>
          <div>
            <div class="font-semibold text-sm">
              {{ 'project.steps.rfd.evaluation.legend.veryInadequate' | transloco }}
            </div>
            <div class="text-xs text-slate-300 mt-0.5">
              {{ 'project.steps.rfd.evaluation.legend.veryInadequate.description' | transloco }}
            </div>
          </div>
        </div>

        <!-- 2 stars -->
        <div
          class="bg-slate-700/60 border border-slate-600 rounded-md px-4 py-3 flex items-start gap-4"
        >
          <div class="flex items-center gap-2 min-w-[88px] text-slate-300">
            <div class="flex items-center gap-0.5">
              <i class="pi pi-star-fill text-red-500 text-sm" aria-hidden="true"></i>
              <i class="pi pi-star-fill text-red-500 text-sm" aria-hidden="true"></i>
              <i class="pi pi-star text-slate-400 text-sm" aria-hidden="true"></i>
              <i class="pi pi-star text-slate-400 text-sm" aria-hidden="true"></i>
            </div>
          </div>
          <div>
            <div class="font-semibold text-sm">
              {{ 'project.steps.rfd.evaluation.legend.partiallyFulfilled' | transloco }}
            </div>
            <div class="text-xs text-slate-300 mt-0.5">
              {{ 'project.steps.rfd.evaluation.legend.partiallyFulfilled.description' | transloco }}
            </div>
          </div>
        </div>

        <!-- 3 stars -->
        <div
          class="bg-slate-700/60 border border-slate-600 rounded-md px-4 py-3 flex items-start gap-4"
        >
          <div class="flex items-center gap-2 min-w-[88px] text-slate-300">
            <div class="flex items-center gap-0.5">
              <i class="pi pi-star-fill text-red-500 text-sm" aria-hidden="true"></i>
              <i class="pi pi-star-fill text-red-500 text-sm" aria-hidden="true"></i>
              <i class="pi pi-star-fill text-red-500 text-sm" aria-hidden="true"></i>
              <i class="pi pi-star text-slate-400 text-sm" aria-hidden="true"></i>
            </div>
          </div>
          <div>
            <div class="font-semibold text-sm">
              {{ 'project.steps.rfd.evaluation.legend.largelyFulfilled' | transloco }}
            </div>
            <div class="text-xs text-slate-300 mt-0.5">
              {{ 'project.steps.rfd.evaluation.legend.largelyFulfilled.description' | transloco }}
            </div>
          </div>
        </div>

        <!-- 4 stars -->
        <div
          class="bg-slate-700/60 border border-slate-600 rounded-md px-4 py-3 flex items-start gap-4"
        >
          <div class="flex items-center gap-2 min-w-[88px] text-slate-300">
            <div class="flex items-center gap-0.5">
              <i class="pi pi-star-fill text-red-500 text-sm" aria-hidden="true"></i>
              <i class="pi pi-star-fill text-red-500 text-sm" aria-hidden="true"></i>
              <i class="pi pi-star-fill text-red-500 text-sm" aria-hidden="true"></i>
              <i class="pi pi-star-fill text-red-500 text-sm" aria-hidden="true"></i>
            </div>
          </div>
          <div>
            <div class="font-semibold text-sm">
              {{ 'project.steps.rfd.evaluation.legend.completelyFulfilled' | transloco }}
            </div>
            <div class="text-xs text-slate-300 mt-0.5">
              {{
                'project.steps.rfd.evaluation.legend.completelyFulfilled.description' | transloco
              }}
            </div>
          </div>
        </div>
      </div>
    </div>
  }
</div>
